import { FormBase } from "../shared/interface/form-base";
import { FormDynamic } from "../shared/interface/form-dynamic";

const FieldsPrimary: FormBase[] = [
    {
        type: "text",
        item: "name",
        label: "nombre del formulario",
        isRequired: true,
    },
    {
        type: "array_fields",
        item: "fields",
        label: "nombre del formulario",
        arrayFields: [
            {
                type: "text",
                item: "item",
                label: "Nombre del item (todo minuscula separado con guiones campo_ejemplo)",
                isRequired: true,
            },
            {
                type: "text",
                item: "label",
                label: "Nombre del Campo",
                isRequired: true,
            },
            {
                item: "type",
                label: "Tipo de campo",
                type: "select",
                isRequired: true,
                options: [],
            }
        ],
        isRequired: true,
    }
]


export const FormPrimary: FormDynamic = {
    id: 'master',
    name: 'Formulario mater',
    user: 'masteradmin@bancolombia.com.co',
    fields: FieldsPrimary,
    version: 1,
    dateCreate: new Date().toDateString(),
    dateEdit: new Date().toDateString(),
  }